<template>
    <mc-modal
        v-model="show"
        append-to-body
        width="600px"
        class="schedule-dlg"
    >
        <template slot="title">
            <div class="dlg-title">
                AI卖点
            </div>
        </template>
        <mc-loading
            :loading="loading"
            :message="loadingText"
            class="container"
        >
            <div>
                <div>当前生成卖点：</div>
                <div v-if="sellPoints.length === 0">
                    暂未生成卖点，请点击重新生成
                </div>
                <template v-else>
                    <mc-tooltip
                        v-for="item in sellPoints"
                        :key="item.point"
                        placement="top"
                    >
                        <mc-button
                            class="btn"
                            type="primary"
                            size="small"
                            icon="mtdicon mtdicon-add"
                            @click="add(item.point)"
                        >
                            {{ item.point }}
                        </mc-button>

                        <div
                            slot="content"
                            name="content"
                        >
                            <div>
                                卖点描述： {{ item.pointDescription }}
                            </div>
                            <div>
                                卖点来源： {{ item.reference }}
                            </div>
                        </div>
                    </mc-tooltip>
                </template>
            </div>
            <div>
                <div>选中卖点：</div>
                <div v-if="selectedSellPoints.length === 0">
                    当前未选中卖点
                </div>
                <template v-else>
                    <mc-button
                        v-for="text in selectedSellPoints"
                        :key="text"
                        class="btn"
                        type="primary"
                        size="small"
                        icon="mtdicon mtdicon-close"
                        @click="remove(text)"
                    >
                        {{ text }}
                    </mc-button>
                </template>
            </div>
        </mc-loading>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <mc-button
                :disabled="loading"
                class="btn"
                type="primary"
                plain
                @click="cancel"
            >
                取消
            </mc-button>
            <mc-button
                :disabled="loading"
                class="btn"
                type="primary"
                @click="reGenerate"
            >
                重新生成
            </mc-button>
            <mc-button
                :disabled="loading"
                type="primary"
                @click="submit"
            >
                添加
            </mc-button>
        </div>
    </mc-modal>
</template>

<script>
import { reportLx } from '@lsfe/tools';
import { getCookie } from '@mcfe/tools';
import { aiSellingData, queryAiData } from '../composables/useSellingPointsBuyerAi';

const AISELLPOINTTYPEENUM = 103;

export default {
    name: 'AiSellPointDlg',
    components: {},
    props: {
        isCreateNewRefer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
            loading: false,
            sellPoints: [],
            selectedSellPoints: [],
            loadingText: '数据加载中，请勿关闭',

            reviewList: [],
            infoData: {},
            pointConfig: {},
        };
    },
    methods: {
        async popup() {
            this.loading = true;
            this.show = true;
            try {
                this.queryAISellPoints();
            } finally { this.loading = false; }
        },

        // 请求卖点
        async queryAISellPoints(type) {
            this.loading = true;
            try {
                if (type === 'again' || !aiSellingData.value.sellingPoints?.length) await queryAiData();
                this.sellPoints = aiSellingData.value.sellingPoints;
                // 卖点生成(重新生成)埋点
                reportLx('moduleClick', 'b_chaoshi_1ci4wfln_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_hnd3fv8y' });
            } catch (e) {
                this.reGenerate('again');
            } finally {
                this.loading = false;
            }
        },

        // 重新生成商品卖点
        async reGenerate(type) {
            this.loadingText = 'AI商品卖点重新生成中...'; // 设置加载提示文本
            this.queryAISellPoints(type);
        },

        /**
         * 添加选中的卖点
         * @param {string} sellPoint - 要添加的卖点
         */
        add(sellPoint) {
            if (this.selectedSellPoints.includes(sellPoint)) {
                this.$mc.message.warning(`卖点【${sellPoint}】已经被选中过。`);
            } else {
                this.selectedSellPoints.push(sellPoint);
            }
        },

        /**
        * 移除选中的卖点
        * @param {string} sellPoint - 要移除的卖点
        */
        remove(sellPoint) {
            const selectedIndex = this.selectedSellPoints.indexOf(sellPoint);
            this.selectedSellPoints.splice(selectedIndex, 1);
        },
        /**
         * 查询卖点是否存在
         * @param {string} sellPointContentName - 卖点内容名称
         * @returns {boolean} - 返回卖点是否存在的结果，存在返回true，不存在返回false
         */
        async querySellPointExist(sellPointContentName) {
            const { resultList = [] } = await this.$hPost(
                '/api/vss/shepherd/product/searchSellPointAllList',
                {
                    sellPointContentName,
                    sellPointTypeId: -1,
                    paging: {
                        offset: 0,
                        limit: 20,
                    },
                },
            );
            return resultList.length !== 0 && resultList.find((item) => item.sellPointContentName === sellPointContentName);
        },

        /**
        * 添加卖点
        * @param {string} sellPointContentName - 卖点内容名称
        * @returns {Object} - 返回添加卖点的结果
        */
        async addSellPoint(sellPointContentName) {
            const res = await this.$hPost(
                '/api/vss/shepherd/productapi/sellpoint/vssAddSellPointContent',
                {
                    sellPointContentId: -1,
                    sellPointContentName,
                    sellPointTypeId: AISELLPOINTTYPEENUM,
                },
            );
            return res;
        },

        // 关闭
        cancel() {
            this.show = false;
        },

        async submit() {
            if (!this.selectedSellPoints.length) {
                this.$mc.message.warning('未选择卖点');
                return;
            }

            try {
                const sellPointItems = [];
                await Promise.all((this.selectedSellPoints || []).map(async (sellPointContentName) => {
                    const sellPointItem = await this.querySellPointExist(sellPointContentName);
                    if (!sellPointItem) {
                        const res = await this.addSellPoint(sellPointContentName);
                        sellPointItems.push({
                            sellPointContentId: res.sellPointContentId,
                            sellPointContentName: res.sellPointContentName,
                            sellPointTypeName: res.sellPointTypeName,
                            sellPointTypeId: res.sellPointTypeId,
                        });
                    }
                    sellPointItems.push(sellPointItem);
                }));
                this.$emit('add', sellPointItems);
                // 卖点生成(重新生成)埋点
                reportLx('moduleClick', 'b_chaoshi_yitk0q5g_mc', { msid: getCookie('msid'), count: sellPointItems.length }, { cid: 'c_chaoshi_hnd3fv8y' });
                await this.$message.success('AI卖点添加成功');
                this.selectedSellPoints = [];
                this.show = false;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.schedule-dlg {
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    margin-right: 4px;
    margin-bottom: 4px;
  }
  /deep/ .el-dialog {
    margin: auto !important;
  }
  /deep/ .el-dialog__header {
    background-color: #ffffff;
    height: auto;
    .dlg-title {
      display: flex;
      font-size: 18px;
      color: #292929;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 500;
      padding: 24px;
    }
    .el-icon-close {
      font-size: 15px;
      color: #000000;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 12px;
  }
  /deep/ .el-dialog__footer {
    background-color: #ffffff;
  }
  .container {
    min-height: 100px;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
